$(document).on('click', '.js-fav', function() {

	const elementId = $(this).data('id');
	const action = $(this).data('action');
	const _this = $(this);

	$.ajax({
		url: action,
		data: {
			sessid: $('meta[name="csrf-token"]').attr('content') || '',
			elementId: elementId
		},
		method: 'POST',
		success: function(response) {
			if (response.status === 'success') {
				if (_this.hasClass('is_active')) {
					_this.removeClass('is_active');
				}
				else {
					_this.addClass('is_active');
				}
				_this.data('action', response.data.ACTION);

				$('.header-favorite-count-js').html(response.data.COUNT);

				if (response.data.COUNT) {
					$('.header-favorite-icon-js').addClass('fav_is_active');
				}else {
					$('.header-favorite-icon-js').removeClass('fav_is_active');
				}

				if (_this.data('reload') == true) {
					url = window.location.href;
					$.ajax({
						url: url,
						success: function(response) {
							const items = $(response).find('.js-favorite-content').html();
							$('.js-favorite-content').empty();
							$('.js-favorite-content').append(items);
						}
					})
				}
			}
		}
	});

	event.preventDefault();
});
